export default "__VITE_ASSET__D4jAgU_K__"